define('extensions/knockout.amdTemplateEngine',[
    'lib/knockout',
    'require'
], function (ko, require) {
    'use strict';

    ko.templateSources.amdTemplate = function (templateName) {
        this.templateName = templateName;
        this.templateData = {};
    };

    ko.utils.extend(ko.templateSources.amdTemplate.prototype, {
        text: function (value) {
            if (arguments.length === 0) {
                // Because this uses the synchronous require call, the binding for the template
                // must handle the ansynchronous template load.
                return this.templateValue || require('text!' + this.templateName + '.html');
            } else {
                this.templateValue = value;
            }
        },
        data: function (key, value) {
            if (arguments.length >= 2) {
                this.templateData[key] = value;
            } else {
                return this.templateData[value];
            }
        }
    });


    ko.amdTemplateEngine = function () {
        var engine = new ko.nativeTemplateEngine();
        engine.makeTemplateSource = function (template) {
            // Named template
            if (typeof template == "string") {
                return new ko.templateSources.amdTemplate(template);
            }
            else if ((template.nodeType == 1) || (template.nodeType == 8)) {
                // Anonymous template
                // Handles the <!-- ko template: { nodes: $componentTemplateNodes } added in ko 3.4
                return new ko.templateSources.anonymousTemplate(template);
            } else {
                throw new Error("Unknown template type: " + template);
            }
        };
        return engine;
    };

    return ko.amdTemplateEngine;
});

